<app-chart-layout
    [subtitle]="computedStatistic().description ?? ''"
    [title]="computedStatistic().name">
    @if (this.totalPieValue()) {
        <div class="flex flex-row items-center h-full">
            <div class="w-2/4 mt-4">
                <app-base-chart
                    [isHeightClassApplied]="false"
                    [isMapExpanded]="isExpanded()"
                    [options]="options()" />
            </div>

            <div class="w-2/4 h-full flex flex-col justify-between overflow-y-auto pr-5">
                <div class="flex-1 flex items-center justify-center pt-4 mb-2">
                    <div class="flex flex-col">
                        @for (item of pieData(); track item.label) {
                            <div
                                class="flex items-center gap-2 pb-2 cursor-pointer"
                                role="button"
                                tabindex="0"
                                [class.font-semibold]="isSelected(item)"
                                (click)="onLegendClick(item)"
                                (keydown.enter)="onLegendClick(item)"
                                (keydown.space)="onLegendClick(item)">
                                <span
                                    class="w-3 h-3 rounded-full"
                                    [style.background-color]="getLegendColor(item)">
                                </span>
                                <span class="text-xs text-outline">{{ item.label }}</span>
                            </div>
                        }
                    </div>
                </div>

                <div class="min-h-13 pt-2 flex items-end justify-end text-right pr-5">
                    @if (legendClickValue()) {
                        <div class="text-xs">
                            <span
                                class="font-semibold px-2 py-1 rounded text-white text-base"
                                style="text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7)"
                                [style.background-color]="legendClickColor()">
                                {{ legendClickValue() }}
                                @if (isExpanded()) {
                                    <span class="pl-1">({{ legendClickValuePercent() }})</span>
                                }
                            </span>
                            @if (!isExpanded()) {
                                <span class="text-on-surface">
                                    {{ legendClickValuePercent() }}
                                </span>
                            }
                            <p class="text-outline">{{ legendClickCategory() }}</p>
                        </div>
                    } @else {
                        <div
                            class="invisible font-semibold px-2 py-1 rounded text-white text-base pb-1"
                            style="text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7)"
                            [style.background-color]="legendClickColor()">
                            placeholder
                            <br />
                            <span class="text-xs">placeholder</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    } @else {
        <div class="flex flex-1 items-center justify-center h-full min-h-56 text-outline">
            <span>{{ 'noStatData' | transloco }}</span>
        </div>
    }
</app-chart-layout>
